import React from 'react';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';

import { HEADER_DROPDOWN_MENU_ITEM_SX } from './headerDropdownStyles';

type HeaderDropdownMenuItemMAIQProps = MenuItemProps;

export const HeaderDropdownMenuItemMAIQ: React.FC<
  HeaderDropdownMenuItemMAIQProps
> = ({ sx, children, ...props }) => (
  <MenuItem sx={[HEADER_DROPDOWN_MENU_ITEM_SX, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]} {...props}>
    {children}
  </MenuItem>
);

export default HeaderDropdownMenuItemMAIQ;
